module.exports = __webpack_public_path__ + "img/LasstUnsLesenImBuchDerWeisheit.b12146f1.svg";